// format 10-digit phone number to what backend/RIMS wants
export const phoneMixin = {
  methods: {
    formatPhoneForRims(str) {
      // web app will only allow exactly 10 digits from user input
      if (str && str.length === 10) {
        return `1-(${str.substr(0, 3)})-${str.substr(3, 3)}-${str.substr(6)}`;
      }
      return str;
    },
    formatPhoneForWebapp(str) {
      if (str) {
        const tmp = str.replace('(', '').replace(')', '').replace(/-/g, '');
        const dig = 10;
        const len = tmp.length;
        if (len > dig) {
          return tmp.substr(len - dig); // last 10 digits
        } else {
          return tmp;
        }
      }
      return str;
    }
  }
};
